export default "__VITE_ASSET__DBhiLRP___"